var $dbdc1942894e83e4$exports = {};
$dbdc1942894e83e4$exports = {
  "dragDescriptionKeyboard": "Stla\u010Den\xEDm kl\xE1vesu Enter za\u010Dnete pres\xFAvanie.",
  "dragDescriptionKeyboardAlt": "Stla\u010Den\xEDm kl\xE1vesov Alt + Enter za\u010Dnete pres\xFAvanie.",
  "dragDescriptionLongPress": "Dlh\xFDm stla\u010Den\xEDm za\u010Dnete pres\xFAvanie.",
  "dragDescriptionTouch": "Dvojit\xFDm kliknut\xEDm za\u010Dnete pres\xFAvanie.",
  "dragDescriptionVirtual": "Kliknut\xEDm za\u010Dnete pres\xFAvanie.",
  "dragItem": function dragItem(args) {
    return "Presun\xFA\u0165 polo\u017Eku ".concat(args.itemText);
  },
  "dragSelectedItems": function dragSelectedItems(args, formatter) {
    return "Presun\xFA\u0165 ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " vybrat\xFA polo\u017Eku");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " vybrat\xE9 polo\u017Eky");
      }
    }));
  },
  "dragSelectedKeyboard": function dragSelectedKeyboard(args, formatter) {
    return "Stla\u010Den\xEDm kl\xE1vesu Enter presuniete ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " vybrat\xFA polo\u017Eku");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " vybrat\xFDch polo\u017Eiek");
      }
    }), ".");
  },
  "dragSelectedKeyboardAlt": function dragSelectedKeyboardAlt(args, formatter) {
    return "Stla\u010Den\xEDm kl\xE1vesov Alt + Enter presuniete ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " vybrat\xFA polo\u017Eku");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " vybrat\xFDch polo\u017Eiek");
      }
    }), ".");
  },
  "dragSelectedLongPress": function dragSelectedLongPress(args, formatter) {
    return "Dlh\xFDm stla\u010Den\xEDm presuniete ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " vybrat\xFA polo\u017Eku");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " vybrat\xFDch polo\u017Eiek");
      }
    }), ".");
  },
  "dragStartedKeyboard": "Pres\xFAvanie sa za\u010Dalo. Do cie\u013Eov\xE9ho umiestnenia prejdete stla\u010Den\xEDm kl\xE1vesu Tab. Ak chcete polo\u017Eku umiestni\u0165, stla\u010Dte kl\xE1ves Enter alebo stla\u010Dte kl\xE1ves Esc, ak chcete pres\xFAvanie zru\u0161i\u0165.",
  "dragStartedTouch": "Pres\xFAvanie sa za\u010Dalo. Prejdite na cie\u013Eov\xE9 umiestnenie a dvojit\xFDm kliknut\xEDm umiestnite polo\u017Eku.",
  "dragStartedVirtual": "Pres\xFAvanie sa za\u010Dalo. Prejdite na cie\u013Eov\xE9 umiestnenie a kliknut\xEDm alebo stla\u010Den\xEDm kl\xE1vesu Enter umiestnite polo\u017Eku.",
  "dropCanceled": "Umiestnenie zru\u0161en\xE9.",
  "dropComplete": "Umiestnenie dokon\u010Den\xE9.",
  "dropDescriptionKeyboard": "Stla\u010Den\xEDm kl\xE1vesu Enter umiestnite polo\u017Eku. Stla\u010Den\xEDm kl\xE1vesu Esc zru\u0161\xEDte pres\xFAvanie.",
  "dropDescriptionTouch": "Dvojit\xFDm kliknut\xEDm umiestnite polo\u017Eku.",
  "dropDescriptionVirtual": "Kliknut\xEDm umiestnite polo\u017Eku.",
  "dropIndicator": "indik\xE1tor umiestnenia",
  "dropOnItem": function dropOnItem(args) {
    return "Umiestni\u0165 na polo\u017Eku ".concat(args.itemText);
  },
  "dropOnRoot": "Umiestni\u0165 na",
  "endDragKeyboard": "Prebieha pres\xFAvanie. Ak ho chcete zru\u0161i\u0165, stla\u010Dte kl\xE1ves Enter.",
  "endDragTouch": "Prebieha pres\xFAvanie. Dvojit\xFDm kliknut\xEDm ho m\xF4\u017Eete zru\u0161i\u0165.",
  "endDragVirtual": "Prebieha pres\xFAvanie.",
  "insertAfter": function insertAfter(args) {
    return "Vlo\u017Ei\u0165 za polo\u017Eku ".concat(args.itemText);
  },
  "insertBefore": function insertBefore(args) {
    return "Vlo\u017Ei\u0165 pred polo\u017Eku ".concat(args.itemText);
  },
  "insertBetween": function insertBetween(args) {
    return "Vlo\u017Ei\u0165 medzi polo\u017Eky ".concat(args.beforeItemText, " a ").concat(args.afterItemText);
  }
};
export { $dbdc1942894e83e4$exports as default };